export const constants = {
    HTTP_CONFLICT: 409,
    SEARCHIFY_LIMIT: 50,
}

constants.CUSTOM_SEARCHIFY_FORM_PROPS = {
    maxSearchifyCount: constants.SEARCHIFY_LIMIT,
    multi: false,
    searchify: true,
    singleSelectSearchify: true,
}

constants.CUSTOM_SEARCHIFY_FORM_PROPS_MULTI = {
    ...constants.CUSTOM_SEARCHIFY_FORM_PROPS,
    multi: true,
    singleSelectSearchify: false,
}

export default constants
